export default __webpack_public_path__ + "static/media/a7.04a8e24b.png";